import { IMultipleIdsParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IRunExtractRefreshesOnWorkbooksParams extends IMultipleIdsParams {
  type: string; // ExtractTaskType
}

export class RunExtractRefreshesOnWorkbooksRequest extends Request<IRunExtractRefreshesOnWorkbooksParams, IResult> {
                          // type must be from ExtractTaskType
  constructor(ids: string[], type: string) {
    super('runExtractRefreshesOnWorkbooks', {
      ids: ids,
      type: type
    });
  }
}
